import React, { Component } from "react";
import { connect } from "react-redux";
import Button from "react-bootstrap-button-loader";
import { Modal } from "react-bootstrap";
import { showError, showSuccess } from "ReduxErrorBar";
import { openCourseModal, clearUnpublished } from "CourseAction";
import CourseNavigation from "./course-navigation";
import LocaleStrings from "Languages";

class AddCourse extends Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {}

  closeModal = () => {
    this.props.openCourseModal({});
    this.props.clearUnpublished();
  };

  finishOperationsCallback = () => {
    this.props.finishOperationsCallback();
  };

  render() {
    var { showModal } = this.props;

    return (
      <div>
        <Modal
          className="modal-container"
          dialogClassName="modal-lg"
          show={showModal && showModal.showModal ? true : false}
          animation={true}
        >
          <Modal.Header>
            <div className="import-modal-title">
              {LocaleStrings.course_title_manage_course}
            </div>
            <button
              type="button"
              className="i-custom-cross-popup pull-right"
              onClick={() => this.closeModal()}
            >
              <img
                className="i-custom-small"
                src="../../style/images/custom-icons/cross-black.png"
              />
            </button>
          </Modal.Header>
          <Modal.Body>
            <div>
              <CourseNavigation
                finishOperationsCallback={this.finishOperationsCallback}
              />
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button className="btn btn-custom-white" onClick={this.closeModal}>
              {LocaleStrings.button_close}
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    session: state.session,
    showModal: state.courseModal,
  };
}

export default connect(mapStateToProps, {
  showError,
  showSuccess,
  openCourseModal,
  clearUnpublished,
})(AddCourse);
